import React from 'react'

export const BeRecipientApiContext = React.createContext({ apiContext: null })
